import React, { Component } from "react";
import ComparerSection from "./ComparerSection";
import HoverGraphic from "./HoverGraphic";
import * as d3 from "d3";

class Comparer extends Component {
  years = [
    "'00",
    "'02",
    "'04",
    "'06",
    "'08",
    "'10",
    "'12",
    "'14",
    "'16",
    "'18",
  ].map((year, i) => (
    <div key={i} className="comparer-year-label">
      {year}
    </div>
  ));

  setActive = (title, d_name, r_name, d_val, r_val) => {
    this.setState({
      title: title,
      d_name: d_name,
      r_name: r_name,
      d_val: d_val,
      r_val: r_val,
    });
  };

  componentDidMount() {
    d3.csv("./data/norco_elex_data.csv").then((data) => {
      this.setState({
        presData: data.filter((row) => row.race === "president"),
        senateData: data.filter((row) => row.race === "us_senate"),
        cong15Data: data.filter((row) => row.race === "fifteenth_cong"),
        cong17Data: data.filter((row) => row.race === "seventeeth_cong"),
      });
    });
  }

  render() {
    return (
      <>
        {this.state && (
          <section id="comparer-graphic">
            <h2 className="section-title">Northampton County Voting Trends</h2>
            <h4>
              Over the past 18 years, Northampton County voter preferences have
              closely matched the preferences of its parent Congressional
              districts, Pennsylvania and the United States as a whole.
            </h4>
            <h4>
              The color of each square represents the margin of victory for the
              election in the given region. More intense colors indicate larger
              margins of victory.
            </h4>
            <div id="comparer-year-container">{this.years}</div>
            <ComparerSection
              activator={this.setActive}
              label="Presidential"
              type="presidential"
              data={this.state.presData}
              altBg
            />
            <ComparerSection
              activator={this.setActive}
              label="Senate"
              type="senate"
              data={this.state.senateData}
            />
            <ComparerSection
              activator={this.setActive}
              label="Congressional (7th/15th)"
              type="congressional"
              data={this.state.cong15Data}
              altBg
            />
            <ComparerSection
              activator={this.setActive}
              label="Congressional (17th)"
              type="congressional"
              data={this.state.cong17Data}
            />
            <h6 className="footnote">
              *For Presidential elections, the United States margin of victory
              is calculated based on the number of electoral college votes won.
            </h6>
            <h6 className="footnote">
              **The 17th Congressional District included Easton and parts of
              the Slate Belt from 2012 until 2016. The Pennsylvania Supreme
              Court invalidated the state’s Congressional map in 2018 and
              Northampton County was removed from the district, which is now
              known as the 8th Congressional District.
            </h6>
            <div id="comparer-hoverbox" className="hoverbox">
              {this.state && (
                <HoverGraphic
                  title={this.state.title}
                  d_name={this.state.d_name}
                  r_name={this.state.r_name}
                  d_val={this.state.d_val}
                  r_val={this.state.r_val}
                />
              )}
            </div>
          </section>
        )}
      </>
    );
  }
}

export default Comparer;
